import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { useAuth } from "../../context/AuthContext";

export const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export const Announcement = () => {
  const { site } = useAuth();
  const w = site?.website;
  if (!w?.show_announcement || !w?.announcement) return null;
  return (
    <div className="bg-emerald-500 px-4 py-2 text-center text-xs font-semibold text-[#06110c]" data-testid="site-announcement">
      {w.announcement}
    </div>
  );
};

export default function PublicLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <Announcement />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
